import styles from "./Navbar.module.css"
import catermatLogo from '../../../assets/images/catermatLogo.svg';
import { useState } from 'react';
import { Menu } from 'lucide-react';
import SearchButton from "../../Button/SearchButton/SearchButton";
import CartButton from "../../Button/CartButton/CartButton";
import { Link } from "react-router-dom";
import UserButton from "../../Button/UserButton/UserButton";
import { useUserContext } from "../../../context/UserContext";
import { useWindowSize } from "../../../hooks/useWindowSize";
import { useCartContext } from "../../../context/CartContext";
import { usePreferences } from "../../../context/PreferencesContext";
import MenuBlock from "../Menu/Menu";
import { useStorageItems } from "../../../context/StorageItemsContext";
import { useProducts } from "../../../context/ProductContext";
import { useCartPriceSummary } from "../../../hooks/useCartPriceSummary";



/**
* Navbar - main version.
* Contains various links, language and currency swittch and a logout option
*
* @returns TSX.Element
*/
const Navbar = () => {
    const { cartOpen, closeCart, openCart, cartData } = useCartContext() // Cart data
    const {loggedIn, logout } = useUserContext(); // User data
    const screenWidth = useWindowSize(); // Screen width
    const { selectedCurrency } = usePreferences(); // Current selected currency
    const [menuOpen, setMenuOpen] = useState<boolean>(false); // Mobile menu open flag
    const { allProducts, packages } = useProducts();
    const { items } = useStorageItems();

    // Use consolidated hook for cart price calculations
    const { indicatorText } = useCartPriceSummary({
        cartData,
        selectedCurrency,
        allProducts,
        packages,
        items,
    });

    return(
        <>
        <MenuBlock display={menuOpen} handleDisplay={setMenuOpen} version="default"/>
            <div className={styles.Navbar}>
                {screenWidth > 700 ? (
                    <>
                    <Link to={"/home"}>
                        <img className={styles.Logo} src={catermatLogo} alt="Catermat Logo"></img>
                    </Link>
                    <div className={styles.NavbarGroup}>
                            <div className={styles.NavbarMenu}>
                            <SearchButton/>
                            <CartButton onClick={cartOpen ? closeCart : openCart} indicatorText={indicatorText}/>
                            <UserButton
                            LoggedIn={loggedIn}
                            logout={logout}
                            />
                        </div>
                    </div>
                    </>
                ) : (
                    <>
                        <Link to={"/home"}>
                            <img className={styles.Logo} src={catermatLogo} alt="Catermat Logo"></img>
                        </Link>
                        <div className={styles.NavbarGroup}>
                            <div className={styles.NavbarMenu}>
                                <CartButton onClick={cartOpen ? closeCart : openCart} indicatorText={indicatorText}/>
                                <button className={styles.BurgerMenu} onClick={()=>setMenuOpen(true)}>
                                    <Menu/>
                                </button>
                            </div>
                        </div>
                    </>
                ) }
            </div>
        </>
    )
};

export default Navbar;

